import type { IconNode } from '../types';

/**
 * @name luggage-cabin
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAyaDgiIC8+CiAgPHBhdGggZD0iTTEwIDJ2NSIgLz4KICA8cGF0aCBkPSJNMTQgMnY1IiAvPgogIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxNCIgeD0iNiIgeT0iNyIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTE0IDIxdi04YTIgMiAwIDEgMC00IDB2OCIgLz4KICA8cGF0aCBkPSJNOCAyMXYxIiAvPgogIDxwYXRoIGQ9Ik0xNiAyMXYxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/luggage-cabin
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const luggageCabin: IconNode = [
  ['path', { d: 'M8 2h8', key: '1ssgc1' }],
  ['path', { d: 'M10 2v5', key: 'llsemf' }],
  ['path', { d: 'M14 2v5', key: 'n3y8zn' }],
  ['rect', { width: '12', height: '14', x: '6', y: '7', rx: '2', key: '15wtl9' }],
  ['path', { d: 'M14 21v-8a2 2 0 1 0-4 0v8', key: 'xs4hmt' }],
  ['path', { d: 'M8 21v1', key: 'aqduy3' }],
  ['path', { d: 'M16 21v1', key: 'oqpg2c' }],
];

export default luggageCabin;
